



















































































import Vue from 'vue'
import moment from 'moment'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from 'ag-grid-community'
import {
  ABSENCES_ASSISTANT_GET_ABSENCE_APPROVE,
  ABSENCES_ASSISTANT_GET_END_DATE,
  ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE,
  ABSENCES_ASSISTANT_GET_PERIODICITY, ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  ABSENCES_ASSISTANT_GET_START_DATE,
  GET_CURRENT_USER_IS_ABSENCE_APPROVE, GET_SELECTED_UI_LANGUAGE
} from '@/store/getter-types'
import { PlanningAssistantPeriodicityPayload } from '@/types/payload'
import { ABSENCES_ASSISTANT_SET_ABSENCE_APPROVE, ABSENCES_ASSISTANT_SET_ABSENCE_DISAPPROVE } from '@/store/action-types'
import { Absence } from '@/model/absences/Absence'
import { SelectedEmployee } from '@/model/absences/SelectedEmployee'
import ConfirmationAbsencesCellRenderer from '@/components/cell-renderer/ConfirmationAbsencesCellRenderer.vue'
import { PeriodicityPlannedAbsenceEmployee } from '@/types'
import * as securityService from '@/services/security-service'
import { SecurityArea, SecurityComponent } from '@/types/enums'

interface ComponentData {
  gridOptions: GridOptions,
  absenceApproved: boolean
  absenceDisapproved: boolean
  isApprovedDisabled: boolean
  overlayNoRowsTemplate: string
  gridFrameworkComponents: Object
  panel: number[]
}

export default Vue.extend({
  name: 'AbsencesEditorFinish',

  components: {
    AgGridVue
  },

  props: {
    editAbsence: Object as () => Absence | undefined,
    isSaveButtonDisabled: Boolean
  },

  data (): ComponentData {
    return {
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('absencesPage.name').toString(), field: 'name' },
          { headerName: this.$t('absencesPage.confirmationFromTheDoctor').toString() , field: 'medicalCertificate', cellRenderer: 'confirmationRenderer' },
          { headerName: this.$t('absencesPage.medicalCertificateValidUntil').toString(), field: 'medicalCertificateValid',
            cellRenderer: (data) => {
              if(data.value) {
                return moment(data.value).format('DD.MM.YYYY')
              } else {
                return ''
              }
            }
          },
          { headerName: this.$t('absencesPage.comment').toString(), field: 'comment' }
        ]
      },

      gridFrameworkComponents: {
        confirmationRenderer: ConfirmationAbsencesCellRenderer
      },

      absenceApproved: false,
      absenceDisapproved: false,
      isApprovedDisabled: false,
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      panel: [0]
    }
  },

  computed: {
    date (): string {
      const dateStart: Date = this.$store.getters[ABSENCES_ASSISTANT_GET_START_DATE]
      const dateEnd: Date = this.$store.getters[ABSENCES_ASSISTANT_GET_END_DATE]

      const dateStartMoment = moment(dateStart)

      let displayDate: string

      if (dateStartMoment.isSame(dateEnd, 'date')) {
        displayDate = dateStartMoment.format('DD.MM.YYYY')
      } else {
        const dateEndMoment = moment(dateEnd)

        displayDate = `${dateStartMoment.format('DD.MM.YYYY')} - ${dateEndMoment.format('DD.MM.YYYY')}`
      }

      return displayDate
    },

    startEndTime (): string {
      const dateStart = moment(this.$store.getters[ABSENCES_ASSISTANT_GET_START_DATE])
      const dateEnd = moment(this.$store.getters[ABSENCES_ASSISTANT_GET_END_DATE])

      return `${dateStart.format('HH:mm')} - ${dateEnd.format('HH:mm')}`
    },

    periodicity (): string {
      const periodicityData: PlanningAssistantPeriodicityPayload = this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY]

      let periodicityString: string = ''

      if (periodicityData.isUnique) {
        periodicityString = this.$t('planningPage.unique').toString()

      } else {
        const days: string[] = periodicityData.weekDayList.map((dayNumber: number): string => {
          return moment().day(dayNumber).locale(this.$store.state.selectedUiLanguage.code).format('dd')
        })

        let periodicityNotUnique: Array<string> = []

        if (days.length) {
          periodicityNotUnique.push(days.join(', '))
        }

        periodicityNotUnique.push(`${this.$t('planningPage.everyWeek').toString()} : ${periodicityData.repeatEveryNthWeek}`)

        if (periodicityData.expireAfterRepetitions > 0) {
          periodicityNotUnique.push(`${this.$t('planningPage.endAfterExecutions').toString()} : ${periodicityData.expireAfterRepetitions}`)
        }

        if (periodicityData.expireAfterDate) {
          const date = moment(periodicityData.expireAfterDate).format('DD.MM.YYYY')

          periodicityNotUnique.push(`${this.$t('planningPage.runUntil').toString()} : ${date}`)
        }

        periodicityString = `${periodicityNotUnique.join('<br />')}`
      }

      return periodicityString
    },

    selectedEmployeeList (): SelectedEmployee[] {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
    },

    periodicityPlannedEmployeeList (): PeriodicityPlannedAbsenceEmployee[] {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
    },

    absenceRequestApproved (): boolean {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_ABSENCE_APPROVE]
    },

    isAbsenceApproved (): boolean {
      return this.$store.getters[GET_CURRENT_USER_IS_ABSENCE_APPROVE]
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isPeriodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY]
    },

    isEditingSerie (): boolean {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE]
    },

    showApproveAbsence (): boolean {
      return securityService.isVisible(SecurityArea.Absences, SecurityComponent.SwitchApprove)
    },
    showRejectAbsence (): boolean {
      return securityService.isVisible(SecurityArea.Absences, SecurityComponent.SwitchRefuse)
    },
    isDisabledApproveAbsence (): boolean {
      return securityService.isDisabled(SecurityArea.Absences, SecurityComponent.SwitchApprove)
    },
    isDisabledRejectAbsence (): boolean {
      return securityService.isDisabled(SecurityArea.Absences, SecurityComponent.SwitchRefuse)
    },
  },

  methods: {
    formattedDate (date: string): string {
      return moment(date, 'DD.MM.YYYY').locale(this.selectedLocale).format('DD.MM.YYYY - dddd')
    },

    formatDate (date: Date): string {
      if(date) {
        return moment(date).format('DD.MM.YYYY')
      } else {
        return ''
      }
    },

    onAbsenceApprovedChange (newVal: boolean): void {
      if (newVal) {
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_APPROVE, true)
      } else {
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_APPROVE, false)
      }
    },

    onAbsenceDisapprovedChange (newVal: boolean): void {
      if(newVal) {
        this.absenceApproved = false
        this.isApprovedDisabled = true
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_APPROVE, false)
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_DISAPPROVE, true)
      } else {
        this.isApprovedDisabled = false
        this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_DISAPPROVE, false)
      }
    },

    onCancelButtonClick (): void {
      this.$emit('cancelButtonClick')
    },

    onSaveButtonClick (): void {
      this.$emit('saveButtonClick')
    },
  },

  mounted (): void {
    if (this.editAbsence && this.editAbsence.requestApproved) {
      this.absenceApproved = true
    }

    if (this.editAbsence && this.editAbsence.requestDisapproved) {
      this.absenceDisapproved = true
      this.isApprovedDisabled = true
      this.absenceApproved = false
    } else {
      this.absenceDisapproved = false
    }

    if(!this.editAbsence) {
      this.absenceApproved = this.isAbsenceApproved
      this.$store.dispatch(ABSENCES_ASSISTANT_SET_ABSENCE_APPROVE, this.absenceApproved)
    }
  }
})
